/* Tabbed mega menu behaviour.
   Listeners are delegated from the document because mega menu markup is
   injected by Concept's Section Rendering API after page load. */
(function () {
  'use strict';

  function panelsOf(root) {
    return Array.from(root.querySelectorAll('[data-mm-panel]'));
  }

  function tabsOf(root) {
    return Array.from(root.querySelectorAll('[data-mm-tab]'));
  }

  function activate(tab) {
    var root = tab.closest('[data-mm-tabs]');
    if (!root) return;

    var tabs = tabsOf(root);
    var panels = panelsOf(root);
    var index = tabs.indexOf(tab);
    if (index === -1) return;

    tabs.forEach(function (t, i) {
      var on = i === index;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.setAttribute('tabindex', on ? '0' : '-1');
    });

    panels.forEach(function (p, i) {
      var on = i === index;
      p.classList.toggle('is-active', on);
      if (on) {
        p.removeAttribute('hidden');
      } else {
        p.setAttribute('hidden', '');
      }
    });
  }

  /* Hover intent ("menu aim"). Switching on every pointerover made the panel
     swap under the cursor while it travelled diagonally from a tab to its
     links, crossing the neighbouring tabs on the way. A hovered tab now only
     activates once the pointer rests on it; while the pointer is heading
     towards the open panel, the switch is held back. */
  var REST_DELAY = 60;
  var AIM_DELAY = 280;
  var AIM_TOLERANCE = 40;

  var locs = [];
  var lastMove = 0;
  var hovered = null;
  var timer = null;

  function slope(a, b) {
    return (b.y - a.y) / (b.x - a.x);
  }

  function aimingAtPanel(root) {
    if (locs.length < 2) return false;
    var panels = root.querySelector('.mm-tabs__panels');
    if (!panels) return false;

    var r = panels.getBoundingClientRect();
    var prev = locs[0];
    var cur = locs[locs.length - 1];
    if (cur.x <= prev.x || cur.x >= r.left) return false;

    var top = { x: r.left, y: r.top - AIM_TOLERANCE };
    var bottom = { x: r.left, y: Math.max(r.bottom, root.getBoundingClientRect().bottom) + AIM_TOLERANCE };

    return slope(cur, top) < slope(prev, top) && slope(cur, bottom) > slope(prev, bottom);
  }

  function schedule(tab, delay) {
    clearTimeout(timer);
    timer = setTimeout(function () {
      if (hovered !== tab) return;
      var root = tab.closest('[data-mm-tabs]');
      var stillMoving = Date.now() - lastMove < AIM_DELAY;
      if (root && stillMoving && aimingAtPanel(root)) {
        schedule(tab, AIM_DELAY);
      } else {
        activate(tab);
      }
    }, delay);
  }

  document.addEventListener('pointermove', function (event) {
    if (event.pointerType === 'touch') return;
    if (!(event.target.closest && event.target.closest('[data-mm-tabs]'))) {
      locs = [];
      return;
    }
    locs.push({ x: event.clientX, y: event.clientY });
    if (locs.length > 3) locs.shift();
    lastMove = Date.now();
  });

  document.addEventListener('pointerover', function (event) {
    if (event.pointerType === 'touch') return;
    var tab = event.target.closest && event.target.closest('[data-mm-tab]');
    hovered = tab || null;
    if (!tab) {
      clearTimeout(timer);
      return;
    }
    if (tab.classList.contains('is-active')) return;

    var root = tab.closest('[data-mm-tabs]');
    schedule(tab, root && aimingAtPanel(root) ? AIM_DELAY : REST_DELAY);
  });

  document.addEventListener('click', function (event) {
    var tab = event.target.closest && event.target.closest('[data-mm-tab]');
    if (!tab) return;
    event.preventDefault();
    clearTimeout(timer);
    activate(tab);
  });

  document.addEventListener('keydown', function (event) {
    var tab = event.target.closest && event.target.closest('[data-mm-tab]');
    if (!tab) return;

    var root = tab.closest('[data-mm-tabs]');
    if (!root) return;

    var tabs = tabsOf(root);
    var i = tabs.indexOf(tab);
    var next = null;

    if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
      next = tabs[(i + 1) % tabs.length];
    } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
      next = tabs[(i - 1 + tabs.length) % tabs.length];
    } else if (event.key === 'Home') {
      next = tabs[0];
    } else if (event.key === 'End') {
      next = tabs[tabs.length - 1];
    }

    if (next) {
      event.preventDefault();
      activate(next);
      next.focus();
    }
  });
})();
